export default () => {
    const bibliographySections = document.querySelectorAll('.blockBibliography');
    const isEnglish = document.documentElement.lang === 'en-US';
    if (bibliographySections.length === 0) return;

    bibliographySections.forEach(section => {
        const moreButton = section.querySelector('.blockBibliography__more');
        const bibliographyList = section.querySelector('.blockBibliography__list');
        const moreText = moreButton.querySelector('span');
        const moreIcon = moreButton.querySelector('div');

        if (moreButton && bibliographyList && moreText) {
            moreButton.addEventListener('click', () => {
                bibliographyList.classList.toggle('show');
                moreIcon.classList.toggle('hide');

                if (bibliographyList.classList.contains('show')) {
                    moreText.textContent = isEnglish ? 'collapse footnotes' : 'zwiń przypisy';
                } else {
                    moreText.textContent = isEnglish ? 'expand footnotes' : 'rozwiń przypisy';
                }
            });
        }
    });
}
